import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import WithHover from 'WithHover';
import styles from '../../../sass/main.scss';
import * as RecipientManagerActions from './RecipientManagerActions';
import RecipientManagerConstants from './RecipientManagerConstants';

class SidePanelTab extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.tabType === RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW) {
      window._track('Add Recipients | Add Recipients', 'Template Builder');
      this.props.showAddRecipientsTab();
    } else {
      window._track('Share Link | Share Link', 'Template Builder');
      this.props.showPublicLinkTab();
    }
  }

  render() {
    const isActiveTab = this.props.activeTab === this.props.tabType;
    const tabTextStyle = {
      color: (this.props.isHover || isActiveTab) ?
        styles.addRecipientsTabTextColorActive : styles.addRecipientsTabTextColor,
      fontWeight: isActiveTab ? 'bold' : 'normal',
    };

    return (
      <div
        className={(isActiveTab) ? `${this.props.className} active` : `${this.props.className}`}
        onMouseOver={this.props.onMouseOver}
        onMouseOut={this.props.onMouseOut}
      >
        <button onClick={this.onClick}>
          <div className="side-panel-img-container">
            <img
              className="side-panel-tab-img"
              alt={this.props.imageAlt}
              src={(this.props.isHover || isActiveTab) ?
                this.props.imageSrcHover : this.props.imageSrc
              }
            />
          </div>
          <div className="side-panel-tab-name" style={tabTextStyle} >
            {this.props.name}
          </div>
        </button>
      </div>
    );
  }
}

SidePanelTab.defaultProps = {
  className: 'side-panel-tab',
  imageAlt: 'Add Recipient',
  imageSrc: '/images/self-serve-builder/side-panel/recipients-icon-default-2x.png',
  imageSrcHover: '/images/self-serve-builder/side-panel/recipients-icon-active-2x.png',
  name: '',
};

SidePanelTab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  imageSrcHover: PropTypes.string,
  isHover: PropTypes.bool.isRequired,
  name: PropTypes.string,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  showAddRecipientsTab: PropTypes.func.isRequired,
  showPublicLinkTab: PropTypes.func.isRequired,
  tabType: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    showAddRecipientsTab: RecipientManagerActions.showAddRecipientsTab,
    showPublicLinkTab: RecipientManagerActions.showPublicLinkTab,
  }, dispatch)
);

export const SidePanelTabWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(SidePanelTab);

const SidePanelTabWithHover = WithHover(SidePanelTabWithRedux);

export default SidePanelTabWithHover;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/SidePanelTab.jsx